/* eslint-disable import/prefer-default-export */
import footerimg from '../images/footer/footer4.png';
import mycpid from '../images/footer/mycpid.png';
import mybchsid from '../images/footer/mybchsid.png';
import mysfhsid from '../images/footer/mysfhsid.png';
import myslhsid from '../images/footer/myslhsid.png';
import myrchsid from '../images/footer/myrchsid.png';
import mywestchesterid from '../images/footer/mywestchesterid.png';
import mysocesid from '../images/footer/mysocesid.png';
import mysghsid from '../images/footer/mysghsid.png';
import myrooseveltid from '../images/footer/myrooseveltid.png';
import mynarbonneid from '../images/footer/mynarbonneid.png';
import myeastvalleyid from '../images/footer/myeastvalleyid.png';
import myvannuystid from '../images/footer/myvannuystid.png';
import mytaftid from '../images/footer/mytaftid.png';
import mymainstreetid from '../images/footer/mymainstreetid.png';
import mymarinadelreyid from '../images/footer/mymarinadelreyid.png';
import mysamueliacademyid from '../images/footer/mysamueliacademyid.png';
import myrivervalleyid from '../images/footer/myrivervalleyid.png';
import myhuntingtonparkid from '../images/footer/myhuntingtonparkid.png';
import mypolyid from '../images/footer/mypolyid.png';
import myfremontid from '../images/footer/myfremontid.png';
import myyubacityid from '../images/footer/myyubacityid.png';
import mybellid from '../images/footer/mybellid.png';
import mylibraacademyid from '../images/footer/mylibraacademyid.png';
import mymaywoodacademyid from '../images/footer/mymaywoodacademyid.png';
import myvapaid from '../images/footer/myvapaid.png';
import mydymallyid from '../images/footer/mydymallyid.png';
import myflemingid from '../images/footer/myflemingid.png';
import mymarkhamid from '../images/footer/mymarkhamid.png';
import mykennedyid from '../images/footer/mykennedyid.png';
import myecrchsid from '../images/footer/myecrchsid.png';
import mynimitzid from '../images/footer/mynimitzid.png'
import mycurtissid from '../images/footer/mycurtissid.png'

export const getSchoolHostname = (hostname) => {
  const hostnameArray = hostname.split('.');
  return hostnameArray[0];
};
export const getSchoolData = () => {
  const schoolHostname = getSchoolHostname(window.location.hostname);
  let base64Img = '';
  let qrCodeColor = '';
  let schoolName = '';

  // if (schoolHostname === 'id-fremont') {
  //   base64Img = footerimg;
  //   qrCodeColor = '#000000';
  //   schoolName = 'John C. Fremont High School';
  // } else if (schoolHostname === 'id-huntington') {
  //   base64Img = footerimg;
  //   qrCodeColor = '#000000';
  //   schoolName = 'Huntington Park High School';
  // } else
  if (schoolHostname === 'id-ecrchs') {
    base64Img = footerimg;
    qrCodeColor = '#000000';
    schoolName = 'El Camino Real Charter High School';
  } else if (schoolHostname === 'mybchsid') {
    base64Img = mybchsid;
    qrCodeColor = '#3b4781';
    schoolName = 'Birmingham Community Charter High School';
  } else if (schoolHostname === 'mysfhsid') {
    base64Img = mysfhsid;
    qrCodeColor = '#000000';
    schoolName = 'San Fernando Senior High School';
  } else if (schoolHostname === 'mycpid') {
    base64Img = mycpid;
    qrCodeColor = '#154421';
    schoolName = 'Canoga Park Senior High School';
  } else if (schoolHostname === 'myslhsid') {
    base64Img = myslhsid;
    qrCodeColor = '#254b99';
    schoolName = 'Steam Legacy High School';
  } else if (schoolHostname === 'mysocesid') {
    base64Img = mysocesid;
    qrCodeColor = '#8e0017';
    schoolName = 'Sherman Oaks Center for Enriched Studies';
  } else if (schoolHostname === 'mysghsid') {
    base64Img = mysghsid;
    qrCodeColor = '#a20000';
    schoolName = 'South Gate High School';
  } else if (schoolHostname === 'myrchsid') {
    base64Img = myrchsid;
    qrCodeColor = '#0057a0';
    schoolName = 'Reseda Charter High School';
  } else if (schoolHostname === 'mywestchesterid') {
    base64Img = mywestchesterid;
    qrCodeColor = '#cf1e0a';
    schoolName = 'Westchester Enriched Sciences Magnets';
  } else if (schoolHostname === 'myrooseveltid') {
    base64Img = myrooseveltid;
    qrCodeColor = '#ad000f';
    schoolName = 'Roosevelt High School';
  } else if (schoolHostname === 'mynarbonneid') {
    base64Img = mynarbonneid;
    qrCodeColor = '#008a00';
    schoolName = 'Nathaniel Narbonne High School';
  } else if (schoolHostname === 'myeastvalleyid') {
    base64Img = myeastvalleyid;
    qrCodeColor = '#3878c7';
    schoolName = 'East Valley High School';
  } else if (schoolHostname === 'myvannuystid') {
    base64Img = myvannuystid;
    qrCodeColor = '#1c1c1c';
    schoolName = 'Van Nuys High School';
  } else if (schoolHostname === 'mytaftid') {
    base64Img = mytaftid;
    qrCodeColor = '#a10202';
    schoolName = 'Taft Charter High School';
  } else if (schoolHostname === 'mymainstreetid') {
    base64Img = mymainstreetid;
    qrCodeColor = '#26469a';
    schoolName = 'Main Street Elementary School';
  } else if (schoolHostname === 'mymarinadelreyid') {
    base64Img = mymarinadelreyid;
    qrCodeColor = '#0c3061';
    schoolName = 'Marina Del Rey Middle School';
  } else if (schoolHostname === 'mysamueliacademyid') {
    base64Img = mysamueliacademyid;
    qrCodeColor = '#e75214';
    schoolName = 'Samueli Academy';
  } else if (schoolHostname === 'myrivervalleyid') {
    base64Img = myrivervalleyid;
    qrCodeColor = '#2c5428';
    schoolName = 'River Valley High School';
  } else if (schoolHostname === 'myhuntingtonparkid' || schoolHostname === 'id-huntington') {
    base64Img = myhuntingtonparkid;
    qrCodeColor = '#de5533';
    schoolName = 'Huntington Park High School & Steam Magnet';
  } else if (schoolHostname === 'mypolyid') {
    base64Img = mypolyid;
    qrCodeColor = '#0a2468';
    schoolName = 'John H. Francis Polytechnic Senior High School';
  } else if (schoolHostname === 'id-fremont' || schoolHostname === 'myfremontid') {
    base64Img = myfremontid;
    qrCodeColor = '#861210';
    schoolName = 'Fremont High School';
  } else if (schoolHostname === 'myyubacityid') {
    base64Img = myyubacityid;
    qrCodeColor = '#f8a900';
    schoolName = 'Yuba City High School';
  } else if (schoolHostname === 'mybellid') {
    base64Img = mybellid;
    qrCodeColor = '#421951';
    schoolName = 'Bell High School';
  } else if (schoolHostname === 'mylibraacademyid') {
    base64Img = mylibraacademyid;
    qrCodeColor = '#d4af46';
    schoolName = 'Libra Academy';
  } else if (schoolHostname === 'mymaywoodacademyid') {
    base64Img = mymaywoodacademyid;
    qrCodeColor = '#030091';
    schoolName = 'Maywood Academy High School';
  } else if (schoolHostname === 'myvapaid') {
    base64Img = myvapaid;
    qrCodeColor = '#002f60';
    schoolName = 'Vapa Legacy High School';
  } else if (schoolHostname === 'mydymallyid') {
    base64Img = mydymallyid;
    qrCodeColor = '#950d0d';
    schoolName = 'Mervyn M Dymally High School';
  } else if (schoolHostname === 'myflemingid') {
    base64Img = myflemingid;
    qrCodeColor = '#021535';
    schoolName = 'Fleming Middle School';
  } else if (schoolHostname === 'mymarkhamid') {
    base64Img = mymarkhamid;
    qrCodeColor = '#062b5d';
    schoolName = 'Edwin Markham Middle School';
  } else if (schoolHostname === 'mykennedyid') {
    base64Img = mykennedyid;
    qrCodeColor = '#dcba5e';
    schoolName = 'John F. Kennedy High School';
  } else if (schoolHostname === 'myecrchsid') {
    base64Img = myecrchsid;
    qrCodeColor = '#dcba5e';
    schoolName = 'El Camino Real Charter High School';
  } else if (schoolHostname === 'mynimitzid') {
    base64Img = mynimitzid;
    qrCodeColor = '#153d7b';
    schoolName = 'Chester W Nimitz Middle School';
  } else if (schoolHostname === 'mycurtissid') {
    base64Img = mycurtissid;
    qrCodeColor = '#dd9e16';
    schoolName = 'Glenn Hammond Curtiss Middle School';
  } else {
    base64Img = footerimg;
    qrCodeColor = '#000000';
    schoolName = 'Test High School';
  }
  return [base64Img, qrCodeColor, schoolName];
};

export const isGoogleLoginSchool = () => {
  const schoolHostname = getSchoolHostname(window.location.hostname);
  const schoolHostnameArray = ['mybchsid', 'mysfhsid', 'mycpid', 'myslhsid', 'mysocesid',
    'mysghsid', 'myrchsid', 'mywestchesterid', 'myrooseveltid', 'mynarbonneid',
    'myeastvalleyid', 'myvannuystid', 'mytaftid', 'mymainstreetid', 'mymarinadelreyid',
    'mysamueliacademyid', 'myrivervalleyid', 'myhuntingtonparkid', 'mypolyid', 'id-huntington',
    'myfremontid', 'id-fremont', 'myyubacityid', 'mybellid', 'mylibraacademyid',
    'mymaywoodacademyid', 'myvapaid', 'mydymallyid', 'myflemingid', 'mymarkhamid', 'mykennedyid', 'myecrchsid', 'id-tesths', 'mynimitzid', 'mycurtissid'];
  return schoolHostnameArray.includes(schoolHostname);
};
